import { gql } from '@/__generated__';

export const GET_MOVEMENT_DATA = gql(`#graphql
  query GetMovementData($movementId: Int!) {
    gateMovement(id: $movementId) {
      gate {
        id
        dataConfiguration {
          minPosition
          maxPosition
        }
        movements2 {
          id
          lastKnownPosition {
            point
            source
            timestamp
          }
          lastBattery
          unit
          precision
          operatingState
        }
      }
      ...GateMovementFragment
    }
  }
`);
